import React from 'react';
import styles from './index.module.scss';

const Report = ({ className }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='44'
        height='44'
        viewBox='0 0 44 44'
        className={className}
    >
        <g transform='translate(-84.25 6.125)'>
            <rect
                width='44'
                height='44'
                rx='5.366'
                transform='translate(84.25 -6.125)'
                className={styles.light}
            />
            <g transform='translate(91.019 0.644)'>
                <g transform='translate(0 11.846)'>
                    <rect width='3.515' height='20.308' rx='1.757' className={styles.dark} />
                    <g transform='translate(6.737 5.811)'>
                        <rect width='3.515' height='14.497' rx='1.757' className={styles.dark} />
                    </g>
                    <g transform='translate(13.473 8.746)'>
                        <rect width='3.515' height='11.562' rx='1.757' className={styles.dark} />
                    </g>
                    <g transform='translate(20.21 5.811)'>
                        <rect width='3.515' height='14.497' rx='1.757' className={styles.dark} />
                    </g>
                    <g transform='translate(26.947)'>
                        <rect width='3.515' height='20.308' rx='1.757' className={styles.dark} />
                    </g>
                </g>
                <g transform='translate(8.462 0)'>
                    <circle
                        cx='6.769'
                        cy='6.769'
                        r='6.769'
                        transform='translate(0 0)'
                        className={styles.dark}
                    />
                    <path
                        d='M212.322,419.674v-2.016a2.279,2.279,0,0,0-1.706-2.154l-.168-.047v2.884l-1.007.245v-3.129l-.168.047a2.279,2.279,0,0,0-1.706,2.154v2.016H206.56v-2.016a3.25,3.25,0,0,1,2.774-3.144l.107-.019v-.668l1.007-.245v.914l.107.019a3.25,3.25,0,0,1,2.774,3.144v2.016Z'
                        transform='translate(-203.176 -410.197)'
                        className={styles.light}
                    />
                </g>
            </g>
        </g>
    </svg>
);

export default Report;
